export default {
  brand: {
    fileShare: 'Condivisione File'
  },
  common: {
    loading: 'Caricamento...',
    confirm: 'Conferma',
    cancel: 'Annulla',
    download: 'Scarica',
    downloadAll: 'Scarica tutto',
    downloadSelected: 'Scarica selezionati',
    selectAll: 'Seleziona tutto',
    deselectAll: 'Deseleziona',
    rootDirectory: 'Directory radice',
    createTime: 'Creato il',
    expireTime: 'Scade il',
    totalSize: 'Dimensione totale',
    noFiles: 'Nessun file'
  },
  share: {
    expired: 'I file condivisi sono scaduti',
    invalidLink: 'Link di condivisione non valido',
    needVerifyCode: 'Inserisci il codice di estrazione',
    verifyCodeLabel: 'Codice',
    verifyCodePlaceholder: 'Inserisci codice di estrazione',
    extractFiles: 'Estrai file',
    extractionCodeError: 'Codice di estrazione errato',
    uuidRequestFailed: 'Richiesta di download fallita',
    selectFilesFirst: 'Seleziona prima i file',
    unknownError: 'Errore sconosciuto'
  },
  error: {
    networkError: 'Errore di rete',
    connectionFailed: 'Impossibile connettersi al dispositivo di condivisione. Il dispositivo potrebbe essere spento, in sospensione o la regione di servizio potrebbe essere cambiata. Contatta chi ha condiviso.',
    outdatedLink: 'Impossibile connettersi al dispositivo di condivisione. Potrebbe essere stato utilizzato un link di condivisione obsoleto. Chiedi a chi ha condiviso di aggiornare il sistema alla v2.0.10 o superiore, l\'APP alla v2.1.5 o superiore e ricopiare il link di condivisione.',
    registryError: 'Errore nel recupero delle impostazioni di penetrazione di rete pubblica. Impossibile connettersi al servizio di Registro.',
    missingRegion: 'Al link di condivisione mancano le informazioni sulla regione di servizio. Chiedi a chi ha condiviso di aggiornare il sistema alla v2.0.10 o superiore, l\'APP alla v2.1.5 o superiore e ricopiare il link di condivisione.'
  }
}
